import { isEqual, keys, pick } from "lodash";

const SETTINGS_APPLIED_TOGETHER = [
  ["logo_type", "logo_text", "logo_scale", "logo_image"],
  ["image_visibility", "text_visibility", "video_visibility"],
  ["font", "font_path"],
];

const changedDisplaySettings = (next: any = {}, previous: any = {}) => {
  const changed = new Set(
    keys(next).filter((key) => !isEqual(next[key], previous[key]))
  );
  SETTINGS_APPLIED_TOGETHER.forEach((group) => {
    if (group.some((key) => changed.has(key))) {
      group.filter((key) => key in next).forEach((key) => changed.add(key));
    }
  });
  return changed.size ? pick(next, Array.from(changed)) : undefined;
};

export const previewChanges = (next: any, previous: any) => {
  if (!previous) return next;

  const message: any = {};
  keys(next).forEach((key) => {
    if (key === "display_settings") {
      const settings = changedDisplaySettings(next[key], previous[key]);
      if (settings) message[key] = settings;
    } else if (!isEqual(next[key], previous[key])) {
      message[key] = next[key];
    }
  });

  return keys(message).length ? message : null;
};
